<div #mainArea class="container-fluid p-0"
  style="height: auto">
  <div class="d-flex flex-column">
    <a href="https://ap-img.static.pub/b/india/Lenovo_Employee_Purchase_Program_2026.pdf"
        target="_blank">
    <div #headerBlock 
      [ngClass]="(screenwidth==='desktop')?'col-12 header p-0':'col-12 header1 p-0'"
      [style]="getHeader()!=null?getHeader():''">
      <div class=" d-flex">
        <div class="hero hero-background h-100"></div>
        <div [ngClass]="screenwidth==='desktop'?'text-white hero-content-full':'text-white hero-content-full'">
          <div
            [ngClass]="screenwidth==='desktop'?'d-flex flex-column justify-content-center h-100 align-items-center ml-5':'d-flex flex-column justify-content-center h-100 align-items-center'">
            <p class="heading"></p>
            <p></p>
          </div>
        </div>
      </div>
    </div>
    </a>

    <div class="mt-2 d-flex w-100 justify-content-center">
      <div class="mx-2">
        <div [class]="highlightedTab==='AP'?'highlight-AP':'no-highlight'"></div>
        <p style="cursor: pointer; color: #303d47; background: #dcd8cc; box-shadow: 2px 2px 8px #9d9273; padding:5px 15px; border-bottom-left-radius: 2px; border-bottom-right-radius: 2px;"
          (click)="changeTab('AP')">Ambassador Program</p>
      </div>
       <div class="mx-2">
        <div [class]="highlightedTab==='EP'?'highlight-EP':'no-highlight'"></div>
        <p style="cursor: pointer; color: #303d47; background: #dcd8cc; box-shadow: 2px 2px 8px #9d9273; padding: 5px 15px; border-bottom-left-radius: 2px; border-bottom-right-radius: 2px;"
          (click)="changeTab('EP')">Employee Program</p>
      </div>
    </div>

    <div class="col-12" style="min-height: 650px;">
      <mat-tab-group class="h-100" [(selectedIndex)]="selectedTabIndex" [animationDuration]="0">
        <mat-tab label="First" class="h-100">

          <div *ngIf="highlightedTab==='EP' && step===1" class="row h-100">
            <div *ngIf="screenwidth==='desktop'" class="col-5"></div>
            <div [ngClass]="screenwidth==='desktop'?'col-6':'col-12'">
              <div [ngClass]="screenwidth!=='mobile'?'d-flex flex-column w-100 mt-5':'d-flex flex-column w-100 mt-1'"
                style="float: right;">
                <p [ngClass]="screenwidth==='desktop'?'card-title text-center':'card-title text-center mt-3'">Employee
                  Purchase Program</p>
                <mat-form-field appearance="outline" class="">
                  <input required matInput [(ngModel)]="employeeValidationData.employeeId" placeholder="Employee ID">
                  <small *ngIf="invalidEmployeeId && !employeeValidationData.employeeId"
                    class="text-danger">{{invalidEmployeeIdTxt}}</small>
                </mat-form-field>


                <mat-form-field appearance="outline" class="">
                  <input required matInput [(ngModel)]="employeeValidationData.emailId" placeholder="Employee Email"
                    pattern="[^()/><\][\\\x22,;|]+">
                  <!--span matSuffix>@lenovo.com</span-->
                  <small *ngIf="invalidEmailId && !employeeValidationData.emailId"
                    class="text-danger">{{invalidEmailIdTxt}}</small>
                </mat-form-field>

                <mat-form-field appearance="outline" class="">
                  <input required matInput [(ngModel)]="employeeValidationData.mobileNo" placeholder="Phone Number"
                    maxlength="10" minlength="10" type="number" oninput="this.value=this.value.slice(0,this.maxLength)">
                  <small *ngIf="invalidMobileNo &&!employeeValidationData.mobileNo"
                    class="text-danger">{{invalidMobileNoTxt}}</small>
                </mat-form-field>

                <p [ngClass]="screenwidth==='desktop'?'':'text-center'"><b>You will receive an OTP via SMS & Email</b></p>
                <div [ngClass]="screenwidth==='desktop'?'w-100':'w-100 text-center'">
                  <!-- [ngClass]="screenwidth==='desktop'? 'red-bg text-white w-50 mt-4 mb-5':'red-bg text-white w-50 mt-0 mb-5'" -->
                  <button mat-raised-button class="red-bg text-white w-50 mb-2"
                    (click)="validateEmployee('EP')">Avail Code<mat-icon aria-hidden="false"
                      aria-label="Example home icon">arrow_right_alt</mat-icon></button>
                </div>
             
                  <div class="support">
                    <p>
                      For support, please write to <a href="mailto:lepp@lenovo.com ">lepp@lenovo.com</a>  
                    </p>
                  </div>
      
              
              </div>
            </div>
          </div>
          <div *ngIf="highlightedTab==='EP' && step===2" class="row h-100">
            <div *ngIf="screenwidth==='desktop'" class="col-5"></div>
            <div [ngClass]="screenwidth==='desktop'?'col-6':'col-12'">
              <div [ngClass]="screenwidth!=='mobile'?'d-flex flex-column w-100 mt-5':'d-flex flex-column w-100 mt-1'"
                style="float: right;">
                <div class="w-100">
                  <p [ngClass]="screenwidth==='desktop'?'card-title text-center':'card-title text-center'">Employee
                    Purchase Program</p>
                  <mat-form-field appearance="outline">
                    <input [(ngModel)]="response.otp" (change)="updateOtpValue()" matInput placeholder="Enter OTP" maxlength="6"
                      oninput="this.value=this.value.slice(0,this.maxLength)">
                  </mat-form-field>
                  <button [disabled]="resendOTP" class=" btn btn-sm red-bg text-white ml-3"
                    (click)="resentOTP('EP')">Resend <ng-container *ngIf="resendOTP"><small>({{otpCounter+'s'}})</small>
                    </ng-container>
                    <ng-container *ngIf="!resendOTP"></ng-container>
                  </button>



                  <p [ngClass]="screenwidth==='desktop'?'my-3':' my-3 text-center'"><b>Please enter OTP sent on your
                      phone number and email</b></p>
                  <div [ngClass]="screenwidth==='desktop'?'w-100':'w-100 text-center'">
                    <button mat-raised-button class="red-bg text-white w-50 mt-4" (click)="submitEP()">Submit<mat-icon
                        aria-hidden="false" aria-label="Example home icon">arrow_right_alt</mat-icon></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="highlightedTab==='EP' && step===3" class="row h-100">
            <div *ngIf="screenwidth==='desktop'" class="col-5"></div>
            <div [ngClass]="screenwidth==='desktop'?'col-6':'col-12'">
              <div [ngClass]="screenwidth!=='mobile'?'d-flex flex-column w-100 mt-5':'d-flex flex-column w-100 mt-5'"
                style="float: right;">
                <p [ngClass]="screenwidth==='desktop'?'card-title text-left':'card-title text-center'">Employee
                  Purchase Program</p>
                <!-- <div class="row">
                  <div class="col-6 mt-lg-2 mt-sm-0 mt-md-2">
                    <span [ngClass]="screenwidth==='desktop'?'text-red-code':'text-red-code text-center'">
                      <span>Lenovo Code : </span>
                      <span #lenOfferCode>{{response.offers[0].code}}</span>
                    </span>
                  </div>
                  <div class="col-2">
                    <button mat-raised-button class="red-bg text-white w-10 button-mar" (click)="copyLenCode()">Copy
                      Code</button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 mt-lg-2 mt-sm-0 mt-md-2">
                    <span [ngClass]="screenwidth==='desktop'?'text-red-code':'text-red-code text-center'">
                      <span>Motorola Code : </span>
                      <span #motoOfferCode>{{response.offers[1].code}}</span>
                    </span>
                  </div>
                  <div class="col-2">
                    <button mat-raised-button class="red-bg text-white w-10 button-mar" (click)="copyMotoCode()">Copy
                      Code</button>
                  </div>
                </div> -->
                <div [ngClass]="screenwidth==='mobile'?' text-center':' text-left'">
                <!-- <p class="mt-1"><strong>you have <span [style.color]="'red'" > {{  response.codeCount - response.code.length }}</span> out of <span [style.color]="'red'" >{{ response.codeCount }}</span> Discount Codes left</strong></p> -->
                <div class="col-12 mt-lg-2 mt-sm-0 mt-md-2">
                  <div *ngFor="let res of response.code; let i = index"> 
                    <ng-container *ngIf="response.code && response.code.length <=response.codeCount">
                    <span [ngClass]="screenwidth==='desktop'?'text-black-code':'text-black-code text-center'">
                      <p class ="mt-1" ><small>Discount code generated on <span >{{res.date}}</span></small></p>
                      <p><span style="color: grey;font-weight: lighter;">LENOVO CODE {{ i + 1 }}: </span>
                      <span #lenOfferCode style="color: grey;" >{{res.code}}</span></p>
                    </span>
                    </ng-container>
                   </div>  
                </div>
                <!-- <div [ngClass]="screenwidth==='desktop'?'w-100':'w-100 text-center'" >
                  <button mat-raised-button class="red-bg text-white w-50 mb-2"
                    (click)="submitEP()" *ngIf="response.code.length < response.codeCount ">Get one more code<mat-icon aria-hidden="false"
                      aria-label="Example home icon">arrow_right_alt</mat-icon></button>
                </div> -->
                <!-- <ng-template #codeLimitReached>
                  <p style="color: red;">Sorry, code limit reached</p>
                </ng-template> -->
                <div *ngIf="response.codeCount >= 1">
                  <p>{{response.desc}}</p>
                </div>
                <!-- <div *ngIf="response.desc === 'Thank you for choosing lenovo'" class="additional-code-section">
                  <p class="mt-3">Thank You! for Choosing Lenovo.</p>
                  <p>Discount code has been sent to your mobile and email ID</p>

                  <small>Didn't receive code? Please reach out to lepp@lenovo.com for any
                    concerns.</small>
                </div> -->
                </div>
               </div> 
              </div>
            </div>
            <div *ngIf="highlightedTab==='EP' && step===1000" class="row h-100">
              <div *ngIf="screenwidth==='desktop'" class="col-5"></div>
              <div [ngClass]="screenwidth==='desktop'?'col-6':'col-12'">
                <div [ngClass]="screenwidth!=='mobile'?'d-flex flex-column w-100 mt-5':'d-flex flex-column w-100 mt-5'"
                  style="float: right;">
                  <p [ngClass]="screenwidth==='desktop'?'card-title text-center':'card-title text-center'">Employee
                    Purchase Program</p>
                  <span [ngClass]="screenwidth==='desktop'?'text-red ':'text-red text-center font-weight-bold'">
                    <img *ngIf="error"
                    src="./assets/sad-red.png" class="mr-3" style="width: 50px;">
                      <img *ngIf="!error"
                      src="./assets/tick.png" class="mr-3" style="width: 50px;"></span>
                  <p class="error my-3" >{{errorMessage}}</p>
                  <div [ngClass]="screenwidth==='desktop'?'w-100':'w-100 text-center'">
                    <button mat-raised-button class="red-bg text-white w-50" (click)="startAgain()">OKAY</button>
                  </div>
                </div>
              </div>
            </div>
            <div style="height:200px;"></div>
        </mat-tab>
        <mat-tab label="Second">
          <div *ngIf="highlightedTab==='AP' && step===1" class="row h-100">
            <div *ngIf="screenwidth==='desktop'" class="col-5"></div>
            <div [ngClass]="screenwidth==='desktop'?'col-6':'col-12'">
              <div [ngClass]="screenwidth!=='mobile'?'d-flex flex-column w-100 mt-5':'d-flex flex-column w-100 mt-1'"
                style="float: right;">
                <p [ngClass]="screenwidth==='desktop'?'card-title text-center':'card-title text-center mt-3'">Ambassador
                  Program</p>
                <mat-form-field appearance="outline">
                  <input required matInput [(ngModel)]="employeeValidationData.employeeId" placeholder="Employee ID">
                  <small *ngIf="invalidEmployeeId && !employeeValidationData.employeeId"
                    class="text-danger">{{invalidEmployeeIdTxt}}</small>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <input required matInput [(ngModel)]="employeeValidationData.emailId" placeholder="Employee Email">
                  <small *ngIf="invalidEmailId && !employeeValidationData.emailId"
                    class="text-danger">{{invalidEmailIdTxt}}</small>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <input required matInput [(ngModel)]="employeeValidationData.mobileNo" placeholder="Phone Number"
                    type="number" maxlength="10" oninput="this.value=this.value.slice(0,this.maxLength)">
                  <small *ngIf="invalidMobileNo &&!employeeValidationData.mobileNo"
                    class="text-danger">{{invalidMobileNoTxt}}</small>
                </mat-form-field>

                <p [ngClass]="screenwidth==='desktop'?'':'text-center'"><b>You will receive an OTP via SMS & Email</b></p>
                <div [ngClass]="screenwidth==='desktop'?'w-100':'w-100 text-center'">
                  <button mat-raised-button class="orange-bg text-white w-50 mb-2"
                    (click)="validateEmployee('AP')">Recommend<mat-icon aria-hidden="false"
                      aria-label="Example home icon">arrow_right_alt</mat-icon></button>
                </div>
                <div class="support">
                  <p>
                    For support, please write to <a href="mailto:lepp@lenovo.com ">lepp@lenovo.com</a>  
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="highlightedTab==='AP' && step===2" class="row h-100">
            <div *ngIf="screenwidth==='desktop'" class="col-5"></div>
            <div [ngClass]="screenwidth==='desktop'?'col-6':'col-12'">
              <div [ngClass]="screenwidth!=='mobile'?'d-flex flex-column w-100 mt-5':'d-flex flex-column w-100 mt-5'"
                style="float: right;">
                <div class="w-100">
                  <p [ngClass]="screenwidth==='desktop'?'card-title text-center':'card-title text-center'">Ambassador
                    Program</p>
                  <mat-form-field appearance="outline">
                    <input matInput [(ngModel)]="response.otp" placeholder="Enter OTP"
                      oninput="this.value=this.value.slice(0,this.maxLength)" maxlength="6">
                  </mat-form-field>
                  <button [disabled]="resendOTP" class=" btn btn-sm red-bg text-white ml-3"
                    (click)="resentOTP('EP')">Resend <ng-container *ngIf="resendOTP"><small>({{otpCounter+'s'}})</small>
                    </ng-container>
                    <ng-container *ngIf="!resendOTP"></ng-container>
                  </button>


                  <p [ngClass]="screenwidth==='desktop'?'my-3':'my-3 text-center'"><b>Please enter OTP sent on your
                      phone number and Email</b></p>
                  <div [ngClass]="screenwidth==='desktop'?'w-100':'w-100 text-center'">
                    <button mat-raised-button class="orange-bg text-white w-50"
                      (click)="captureAPFamilyDetails()">Recommend<mat-icon aria-hidden="false"
                        aria-label="Example home icon">arrow_right_alt</mat-icon></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="highlightedTab==='AP' && step===3" class="row h-100">
            <div *ngIf="screenwidth==='desktop'" class="col-5"></div>
            <div [ngClass]="screenwidth==='desktop'?'col-6':'col-12'">
              <div [ngClass]="screenwidth!=='mobile'?'d-flex flex-column w-100 mt-5':'d-flex flex-column w-100 mt-5'"
                style="float: right;">
                <p [ngClass]="screenwidth==='desktop'?'card-title text-center':'card-title text-center'">Ambassador
                  Program</p>
                  <strong>You have <span class="orange-text">{{response.slotsAvailable}}</span> of <span
                      class="orange-text">{{response.totalSlots}}</span> invites left</strong>
                  <ng-container *ngIf="response.familyDetails!==undefined">
                    <div class="row">
                      <ng-container *ngFor="let f of response.familyDetails;let i=index">
                      <div class="col-5 pr-0">

                          <mat-form-field appearance="outline" class="w-100">
                            <input matInput [(ngModel)]="f.name" placeholder="Name" [disabled]="!f.canDelete">
                          </mat-form-field>


                        </div>
                        <div class="col-5 pr-0">
                          <mat-form-field appearance="outline" class="w-100">
                            <input matInput [(ngModel)]="f.mobileNo" placeholder="Phone Number" type="number"
                              [disabled]="!f.canDelete" oninput="this.value=this.value.slice(0,this.maxLength)"
                              maxlength="10">
                          </mat-form-field>
                        </div>
                        <div class="col-2 px-0">
                          <mat-icon *ngIf="f.canDelete" class="orange-text" (click)="deleteRow(i)">delete</mat-icon>
                        </div>

                      </ng-container>
                    </div>
                  </ng-container>

                  <button *ngIf="(this.response.familyDetails && this.response.familyDetails.length < this.response.totalSlots)" class="btn btn-link orange-text"
                    style="display: flex;align-items: center;text-decoration: none;" (click)="addMoreRows()"
                    [disabled]="response.familyDetails.length >= response.totalSlots || response.slotsAvailable === 0">
                    <mat-icon>add_circle_outline</mat-icon>Add More
                  </button>

                  <br>
                  <div [ngClass]="screenwidth==='desktop'?'w-100':'w-100 text-center'">
                  <button mat-raised-button [disabled]="validateFamilyDetails()" class="orange-bg text-white w-50 my-3"
                      (click)="submitAP()">Recommend<mat-icon aria-hidden="false" aria-label="Example home icon">
                        arrow_right_alt</mat-icon></button>
                  </div>
              
              </div>
            </div>
          </div>
          <div *ngIf="highlightedTab==='AP' && step===4" class="row h-100">
            <div *ngIf="screenwidth==='desktop'" class="col-5"></div>
            <div [ngClass]="screenwidth==='desktop'?'col-6':'col-12'">
              <div [ngClass]="screenwidth!=='mobile'?'d-flex flex-column w-100 mt-5':'d-flex flex-column w-100 mt-5'"
                style="float: right;">
                <p [ngClass]="screenwidth==='desktop'?'card-title text-center':'card-title text-center'">Ambassador
                  Program</p>
                <span class="text-red text-center mt-3"> <img src="./assets/tickap.png" class="mr-3"
                    style="width: 50px;"></span>
                <p class="my-3 text-center">Thank You for Choosing Lenovo. Your Special codes has been sent to provided numbers.</p>


              </div>
            </div>
          </div>
          <div *ngIf="highlightedTab==='AP' && step===1000" class="row h-100">
            <div *ngIf="screenwidth==='desktop'" class="col-5"></div>
            <div [ngClass]="screenwidth==='desktop'?'col-6':'col-12'">
              <div [ngClass]="screenwidth!=='mobile'?'d-flex flex-column w-100 mt-5':'d-flex flex-column w-100 mt-5'"
                style="float: right;">
                <p [ngClass]="screenwidth==='desktop'?'card-title text-center':'card-title text-center'">Ambassador
                  Program</p>
                <span [ngClass]="screenwidth==='desktop'?'text-orange':'text-orange text-center'"> <img
                    src="./assets/sad-orange.png" class="mr-3" style="width: 50px;"></span>
                <p class="error my-3">{{errorMessage}}</p>
                <button mat-raised-button class="orange-bg text-white w-50" (click)="startAgain()">OKAY</button>
              </div>
            </div>
          </div>
        </mat-tab>

      </mat-tab-group>
      <!-- <p class="support">
        For support, please write to <a href="mailto:ceppsupport@lenovo.com ">ceppsupport@lenovo.com</a>  
       </p> -->
       <img class="tab-image" *ngIf="tabImage" src="assets/ep_1_m.png" alt="">
    </div>
 
  </div>

</div>

<router-outlet></router-outlet>